import { toTimestamp } from '@mi-front/core';
import { StreamEl } from '@mi-front/ui';
import CallToActionOutlinedIcon from '@mui/icons-material/CallToActionOutlined';
import { useTheme } from '@mui/material';
import { desaturate } from 'polished';
import Popup from 'reactjs-popup';
import AdOverlayInfo from '../adoverlay/AdoverlayInfo';
import { FormattedAdoverlayMarkerType } from '../adoverlay/utils';
import { MatchMarker } from './elements';

interface Props {
  readonly adOverlay: FormattedAdoverlayMarkerType;
}

export function AdOverlayMarker({ adOverlay }: Props) {
  const muiTheme = useTheme();
  return (
    <StreamEl key={adOverlay.date} ts={toTimestamp(adOverlay.date)} offsetX={-18} zIndex={10}>
      <Popup
        trigger={
          <MatchMarker color={desaturate(0.2, '#2bcf57')}>
            <CallToActionOutlinedIcon fontSize="small" style={{ marginTop: '-6px' }} />
          </MatchMarker>
        }
        position="bottom center"
        on="hover"
        contentStyle={{
          borderRadius: 6,
          minWidth: 200,
          width: 'auto',
          background: muiTheme.palette.background.paper,
          color: muiTheme.palette.text.primary,
          border: `1px solid ${muiTheme.palette.divider}`,
        }}
      >
        <AdOverlayInfo adOverlay={adOverlay} />
      </Popup>
    </StreamEl>
  );
}
